import { render } from "./modeltable.vue?vue&type=template&id=100dc417"
import script from "./modeltable.vue?vue&type=script&lang=js"
export * from "./modeltable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__